import React from "react";
import { getMenuItemLabels } from "../../helpers/foodLabelUtils";

interface IMenuItemLabelProps {
  labels: string[];
}

const MenuItemLabel = ({ labels }: IMenuItemLabelProps) => {
  const labelIcons = getMenuItemLabels(labels);

  return (
    <div className="menu-item-label d-flex flex-row">
      {labelIcons.map((icon, index) => (
        <img
          src={icon}
          alt="label"
          key={index}
          className="menu-item-label-icon"
        />
      ))}
    </div>
  );
};

export default MenuItemLabel;
